import { render, staticRenderFns } from "./EducationService.vue?vue&type=template&id=3e62f0f7"
import script from "./EducationService.vue?vue&type=script&lang=js"
export * from "./EducationService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports